<template>
  <h5 class="subTitle">{{text}}</h5>
</template>

<script>
  export default {
    name: "SubTitle",
    props: ['text']

  }
</script>

<style lang="scss">
  .subTitle {
    color: color(grey-soft);
    font-size: rem(14px);
    line-height: rem(24px);
    margin: rem(4px) 0 0;
    @include openSansLight;
  }
</style>